//SHUTTER HERO MENU
window.addEventListener('load', ()=> {
    // HERO
    const heroMenu = document.querySelector('.hero-menu')
    if(heroMenu)
        heroMenu.classList.add('shutter')  

    // ニュース
    if(window.innerWidth < 640) {
        let news = document.querySelectorAll(".swiperNews")
        news.forEach(slides => {
            var swiperNews = new Swiper(slides, {
                slidesPerView: 1,
                spaceBetween: 10,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable:true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        });
    }
    
    // 特集・キャンペーン情報
    let campaign = document.querySelectorAll(".campaign-slider")
    campaign.forEach(slides => {

        var swiperCampaign = new Swiper(slides, {

            loop:true,
            slidesPerView: 1.2,
            spaceBetween: 10,
            loadPrevNext:true,
            lazy: true,
          centeredSlides:true,
         
            on: {
                init: (e)=> { 
                    e.el.classList.remove('slideshow--loading')
                }
            },


            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                  spaceBetween: 10,
                    centeredSlides:true,
                },
                1000: {
                    slidesPerView: 2,
                  spaceBetween: 10,
                    centeredSlides:false,
                },
                1200: {
                    slidesPerView: 3,
                  spaceBetween: 10,
                    centeredSlides:false,
                }
             

            },
            autoplay: {
                delay: 2000,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable:true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });


    });


})

